/**
  * 选品接口
  */

//  import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const selectgoods = {
  findList: params => {
    return axios.get('/json', params)
  },
  findById: id => {
    return axios.get(`/api/enterprise/list/${id}`)
  },

   // 获取门店信息  有分页（马仔文）
  getOrg2013DetailPage (params) {
      return axios.post('/commoditymanagement/org2013/getOrg2013DetailPage',qs.stringify(params));
    },

      // 新增门店信息  有分页（马仔文）
  insertOrg2013 (params) {
      return axios.post('/commoditymanagement/org2013/insertOrg2013',qs.stringify(params));
    },

         // 修改门店信息  有分页（马仔文）
  updateOrg2013 (params) {
      return axios.post('/commoditymanagement/org2013/updateOrg2013',qs.stringify(params));
    },

         // 删除门店信息  有分页（马仔文）
  deleteOrg2013 (params) {
      return axios.post('/commoditymanagement/org2013/deleteOrg2013',qs.stringify(params));
    },

   // 获取门店信息  有分页（马仔文）
  getShopListPage (params) {
      return axios.post('/commoditymanagement/goodsHjRule/getShopListPage',qs.stringify(params));
    },

    // 商品类型管理  有分页（王闯）
  getItemDeptsAndClass (params) {
      return axios.post('/commoditymanagement/itemDept/getItemDeptsAndClass',qs.stringify(params));
    },

     // 商品类型管理 新增（王闯）
  insertItem (params) {
      return axios.post('/commoditymanagement/item/insertItem',qs.stringify(params));
    },

       // 商品类型管理 修改（王闯）
  updateItem (params) {
      return axios.post('/commoditymanagement/item/updateItem',qs.stringify(params));
    },

          // 商品类型管理 删除（王闯）
  deleteItem (params) {
      return axios.post('/commoditymanagement/item/deleteItem',qs.stringify(params));
    },


   // 获取 棚格图与门店映射管理信息  有分页（马仔文）
  getGoodsHjRuleDetailPage (params) {
      return axios.post('/commoditymanagement/goodsHjRule/getGoodsHjRuleDetailPage',qs.stringify(params));
    },

    // 新增 棚格图与门店映射管理信息 （马仔文）
  insertGoodsHjRule (params) {
      return axios.post('/commoditymanagement/goodsHjRule/insertGoodsHjRule',qs.stringify(params));
    },

     // 修改 棚格图与门店映射管理信息 （马仔文）
  updateGoodsHjRule (params) {
      return axios.post('/commoditymanagement/goodsHjRule/updateGoodsHjRule',qs.stringify(params));
    },

       // 删除 棚格图与门店映射管理信息 （马仔文）
  deleteGoodsHjRule (params) {
      return axios.post('/commoditymanagement/goodsHjRule/deleteGoodsHjRule',qs.stringify(params));
    },

  // 棚格图分页列表（马仔文）
  getLayoutCategoryPage (params) {
      return axios.post('/commoditymanagement/serviceApi/getLayoutCategoryPage',qs.stringify(params));
    },

    // 棚格图分类信息-棚格图（马仔文）
    getLayoutCategory (params) {
        return axios.post('/commoditymanagement/serviceApi/getSpaceClass',qs.stringify(params));
    },

    // 棚格图分类信息-修改中标数（马仔文）
    updateBatchBiddingSku:  params => {
			return axios.post('/commoditymanagement/serviceApi/updateBatchBiddingSku',params);

		},
//  // 棚格图分类信息-修改中标数（马仔文）
//  updateBatchBiddingSku (params) {
//      return axios.post('/commoditymanagement/serviceApi/updateBatchBiddingSku',params);
//  },

		// 货架SKU数量管理 - 新增（马仔文）
    insertGoodsSkuRule (params) {
        return axios.post('/commoditymanagement/goodsSkuRule/insertGoodsSkuRule',qs.stringify(params));
    },
    // 货架SKU数量管理 - 修改（马仔文）
    updateGoodsSkuRule (params) {
        return axios.post('/commoditymanagement/goodsSkuRule/updateGoodsSkuRule',qs.stringify(params));
    },

    // 棚格图分类信息-细分类（马仔文）
    getSlenderClass (params) {
      return axios.post('/commoditymanagement/serviceApi/getSlenderClass',qs.stringify(params));
    },

    // 棚格图分类信息-细分类  新增（马仔文）
    insertSpacemanReclass (params) {
      return axios.post('/commoditymanagement/spacemanReclassRule/insertSpacemanReclass',qs.stringify(params));
    },

    // 棚格图分类信息-细分类  修改（马仔文）
    updateSpacemanReclass (params) {
      return axios.post('/commoditymanagement/spacemanReclassRule/updateSpacemanReclass',qs.stringify(params));
    },

    // 棚格图分类信息-细分类  删除（马仔文）
    deleteSpacemanReclass (params) {
      return axios.post('/commoditymanagement/spacemanReclassRule/deleteSpacemanReclass',qs.stringify(params));
    },

    // 货架SKU（马仔文）
    getShelvesSkuRulePage (params) {
      return axios.post('/commoditymanagement/serviceApi/getShelvesSkuRulePage',qs.stringify(params));
    },

    // 货架SKU-商品大类（马仔文）
    getGoodsCategories (params) {
      return axios.post('/commoditymanagement/serviceApi/getGoodsCategories',qs.stringify(params));
    },

    // 货架SKU-商品大类（王闯）
//  getGoodsCategoriesNew (params) {
//    return axios.post('/commoditymanagement/itemDept/itemDeptList',qs.stringify(params));
//  },

     // 货架SKU-商品大类（马仔文）  在用
    getDeptData (params) {
      return axios.post('/commoditymanagement/goodsSkuRule/getDeptData',qs.stringify(params));
    },

      // 货架SKU-棚格图分类（马仔文）  在用
    getLayoutCodeData (params) {
      return axios.post('/commoditymanagement/goodsSkuRule/getLayoutCodeData',qs.stringify(params));
    },

       // 货架SKU-棚格图分类  查询（马仔文）
    deleteGoodsSkuRule (params) {
      return axios.post('/commoditymanagement/goodsSkuRule/deleteGoodsSkuRule',qs.stringify(params));
    },


       // 货架SKU-棚格图分类  删除（马仔文）
    getGoodsSkuRuleDetailPage (params) {
      return axios.post('/commoditymanagement/goodsSkuRule/getGoodsSkuRuleDetailPage',qs.stringify(params));
    },


    // 商品标签特征-免死、淘汰提交(王闯)
    addTtemLabel (params) {
      return axios.post('/commoditymanagement/ttemLabel/addTtemLabel',qs.stringify(params));
    },

    // 必细类下拉框 （王闯）
    getItemSsubClsList (params) {
      return axios.post('/commoditymanagement/itemSsubCls/itemSsubClsList',qs.stringify(params));
    },

    // 必选数量接口 （王闯）
    getPageItemSsubclsExtendss (params) {
      return axios.post('/commoditymanagement/itemSsubclsExtends/getPageItemSsubclsExtendss',qs.stringify(params));
    },

    // 商品大类列表-下拉框 （王闯）
    getItemDeptList (params) {
      return axios.post('/commoditymanagement/itemDept/itemDeptList',qs.stringify(params));
    },

    // 规则查询-必选细分类查看(王闯)
    getSsubclassResult (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/getSsubclassResult',qs.stringify(params));
    },

    // 规则查询-必选细分类查看(余开来)
    showItemssubclsDefineAlterAppDetail (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/showItemssubclsDefineAlterAppDetail',qs.stringify(params));
    },

    // 必选细分类修改(余开来)

    //选品规则查询页-细分类下拉框(王闯)
    getSsubclassResultBySpaceClass (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/getSsubclassResultBySpaceClass',qs.stringify(params));
    },

    //选品规则查询页-免死(王闯)
    getFreeItemByItem (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/getFreeItemByItem',qs.stringify(params));
    },

    //选品规则查询页-淘汰(王闯)
    getEliminateItemByItem (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/getEliminateItemByItem',qs.stringify(params));
    },

    //选品规则-必选细分类修改(余开来)
    getSsubclassChange (params) {
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/updateItemssubclsDefineAlterAppDetail',qs.stringify(params));
      // return axios({
      //   method: 'post',
      //   url: 'http://10.12.29.115:8080/itemelectRulealterResultApp/updateItemssubclsDefineAlterAppDetail',
      //   data: qs.stringify(params),
      //   headers:{'Content-Type':'application/x-www-form-urlencoded'}
      // });
    },

    //选品新增 （余开来）
    getSelectionBillAdd (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/selectionBillAdd',qs.stringify(params));
    },
    //选品单单条查询（余开来）
    getSelectionBill(params){
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/getByPrimaryKey',qs.stringify(params));
    },
    //选品单修改 （余开来）
    UpdateSelectionBillUP (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/selectionBillUP',qs.stringify(params));
    },
    //选品分页查询 （余开来）
    getSelectionBillpageList (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/pageList',qs.stringify(params));
    },
    //选品规则修改申请单新增
    addRulealterAppAdd (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/rulealterAppAdd',qs.stringify(params));
    },
    // 选品规则修改 - - 新增
    insertItemelectRulealterApp (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/insertItemelectRulealterApp',qs.stringify(params));
    },

    //根据选品单ID 查询选品修改单
    getRulealterAppBysipId (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/getRulealterAppBysipId',qs.stringify(params));
    },
    //根据选品单Id 查询版本列表
    getWijVersionListBySipId(params){
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/getWijVersionListBySipId',qs.stringify(params));
    },
    //选品规则修改申请单分页查询 （余开来）
    getItemelectRuleList (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/pageList',qs.stringify(params));
    },

    //选品规则修改申请单 状态修改
    // updateRulealterAppStatus (params) {
    //   return axios.post('/scm-selectionmanager/ItemelectRulealterApp/updateRulealterAppStatus',qs.stringify(params));
    // },
    //选品规则修改申请单 状态修改
    updateRulealterAppStatus (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/ItemelectRulealterAppSubmit',qs.stringify(params));
    },

    //选品规则修改申请单 审核
    RuleExamine (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/examine',qs.stringify(params));
    },

    //选品规则修改申请单 驳回
    itemelectRulealterAppReject (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/itemelectRulealterAppReject',qs.stringify(params));
    },

    //选品规则详情获取 （余开来）
    getRuleItemListDetail (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/getRuleItemList',qs.stringify(params));
    },

    //选品权重版本查询 （余开来）
    showListByWijVersion (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/showListByWijVersion',qs.stringify(params));
    },

    //查询细分类权重指标 （余开来）
    getSWFList (params) {
      return axios.post('/scm-selectionmanager/ItemssubclsSelectionWeightFactor/getSWFList',qs.stringify(params));
    },

    //修改细分类权重 查询权重信息 （余开来）
    getUpdateSWFList (params) {
      return axios.post('/scm-selectionmanager/ItemssubclsSelectionWeightFactor/getUpdateSWFList',qs.stringify(params));
    },

    // 提交细分类权重指标 （余开来）
    submitSelectionWeightFactor (params) {
      return axios.post('/scm-selectionmanager/ItemssubclsSelectionWeightFactor/submitSelectionWeightFactor',qs.stringify(params));
    },

    //选品规则 权重查询 （余开来）
    getShowAppdetailList (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/showAppdetailList',qs.stringify(params));
    },

    // 选品规则 权重修改 （余开来）
    updateAppdetailList (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/updateAppdetailList',qs.stringify(params));
      // return axios({
      //   method: 'post',
      //   url: '/scm-selectionmanager/ItemelectRulealterApp/updateAppdetailList',
      //   data: qs.stringify(params),
      //   // responseType: 'blob'
      //   headers:{'Content-Type':'application/json'}
      // });
    },

    // 选品单号查询 小版本单号 （余开来）
    getSipCode (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/getSipCode',qs.stringify(params));
    },

    //获取权重标签信息 （余开来）
    getWeightFactorDefine (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/getWeightFactorDefine',qs.stringify(params));
    },

    //新增选品申请修改单明细 （余开来）
    addRulealterAppDetail (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/addRulealterAppDetail',qs.stringify(params));
    },

    //删除选品申请修改单明细 （余开来）
    deleteRulealterAppDetail (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/deleteRulealterAppDetail',qs.stringify(params));
    },

    //删除选品单（余开来）
    deleteItemmasterSelectionBill (params) {
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/deleteItemmasterSelectionBill',qs.stringify(params));
    },

    //删除申请单（余开来）
    deleteRulealterApp (params) {
      return axios.post('/scm-selectionmanager/ItemelectRulealterApp/deleteRulealterApp',qs.stringify(params));
    },

    //选品状态接口（谭凯帆）
    getStatusBySipId(params){
      return axios.post('/scm-selectionmanager/itemelectRulealterResultApp/getStatusBySipId',qs.stringify(params));
    },

    //选品单提交 （王永超）
    updateResult(params){
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/submit',params);
    },

    //选品单导出（王永超）
    exportExcel(params){
      return axios({
        method: 'post',
        url: '/scm-selectionmanager/itemselectresultMessage/exportExcel',
        data: qs.stringify(params),
        timeout: 1000 * 60 * 2,
        responseType: 'blob'
      });
    },

    //异常项查看（王永超）
    msgExceptionInfo(params){
      return axios.post('/scm-selectionmanager/ItemselectresultMsg/msgExceptionInfo',params);
    },

    //选品单选品 (谭凯帆)
    selectBill(params){
      return axios.post('/scm-selectionmanager/ItemSelection/getItems',qs.stringify(params));
    },

    //选品结果列表查询 （王永超）
    getSelectItemselectresult (params) {
      return axios.post('/scm-selectionmanager/itemselectresultMessage/selectItemselectresult',qs.stringify(params));
    },

    // 导出接口-细分类 (王闯)
    exSsubcls (params){
      return axios({
        method: 'post',
        url: '/commoditymanagement/itemSsubclsExtends/getPageItemSsubclsExtendssExcel',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
    // 导出接口-选择规则-必选细分类 (王闯)
    exSsubclassResult (params){
      return axios({
          method: 'post',
          url: '/scm-selectionmanager/itemelectRulealterResultApp/exportSsubclassResult',
          data: qs.stringify(params),
          responseType: 'blob'
      })
    },
    // 导出接口-选择规则-淘汰不选 (王闯)
    exEliminateByItem (params){
      return axios({
          method: 'post',
          url: '/scm-selectionmanager/itemelectRulealterResultApp/exportEliminateByItem',
          data: qs.stringify(params),
          responseType: 'blob'
      })
    },
    // 导出接口-选择规则-免死必选 (王闯)
    exFreeItemByItem (params){
      return axios({
          method: 'post',
          url: '/scm-selectionmanager/itemelectRulealterResultApp/exportFreeItemByItem',
          data: qs.stringify(params),
          responseType: 'blob'
      })
    },
    // 导出接口-棚格图 (马仔文)
    exSpaceClass (params){
      return axios({
        method: 'post',
        url: '/commoditymanagement/serviceApi/exportSpaceClass',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
    // 导出接口-货架SKU (马仔文)
    exGoodsSku (params){
      // axios.defaults.responseType = 'blob';
      // return axios.post('/inv-innovatemanager/plan/expPlan', qs.stringify(params));
      return axios({
        method: 'post',
        url: '/commoditymanagement/serviceApi/exportGoodsSkuRule',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
    //根据选品单获取选品Id
    getSipIdBySipCode(params){
      return axios.post('/scm-selectionmanager/ItemmasterSelectionBill/getSipIdBySipCode',qs.stringify(params));
    },
    //根据选品ID和版本号查询免死淘汰商品归档
    getItemmasterSpecsignVersionList(params){
      return axios.post('/scm-selectionmanager/ItemmasterSpecsignVersion/getItemmasterSpecsignVersionList',qs.stringify(params));
    },
    //免死淘汰商品归档下载
    downloadItemmasterSpecsignVersionList (params){
      // axios.defaults.responseType = 'blob';
      // return axios.post('/inv-innovatemanager/plan/expPlan', qs.stringify(params));
      return axios({
        method: 'post',
        url: '/scm-selectionmanager/ItemmasterSpecsignVersion/downloadItemmasterSpecsignVersionList',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
    //根据选品ID和版本号查询细分类必选归档
    getItemssubclsFactorVersionList(params){
      return axios.post('/scm-selectionmanager/ItemssubclsFactorVersion/getItemssubclsFactorVersionList',qs.stringify(params));
    },
    //细分类必选归档下载
    downloadItemssubclsFactorVersionList (params){
      // axios.defaults.responseType = 'blob';
      // return axios.post('/inv-innovatemanager/plan/expPlan', qs.stringify(params));
      return axios({
        method: 'post',
        url: '/scm-selectionmanager/ItemssubclsFactorVersion/downloadItemssubclsFactorVersionList',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
    //根据选品ID和版本号查询棚格图版型归档
    getSpacecodeSpecQuotaVersionList(params){
      return axios.post('/scm-selectionmanager/spacecodeSpecQuotaVersion/getSpacecodeSpecQuotaVersionList',qs.stringify(params));
    },
    //棚格图版型归档下载
    downloadSpacecodeSpecQuotaVersionList (params){
      // axios.defaults.responseType = 'blob';
      // return axios.post('/inv-innovatemanager/plan/expPlan', qs.stringify(params));
      return axios({
        method: 'post',
        url: '/scm-selectionmanager/spacecodeSpecQuotaVersion/downloadSpacecodeSpecQuotaVersionList',
        data: qs.stringify(params),
        responseType: 'blob'
      })
    },
}

export default selectgoods ;



// WEBPACK FOOTER //
// ./src/api/api_selectgoods.js